<div class="main-container" [style]="containerStyle">
    <div [ngClass]="{'caution-container': !isWarning,'warning-container' : isWarning }" [style]="msgBodyStyle">
        <div>
            <img
                [src]="isWarning ? sharedService.imagesUrl + 'warning-icon.svg' : sharedService.imagesUrl + 'Icon-triangle.svg'" />
        </div>
        <div class="text-container">
            <h3 class="heading-class">{{heading}}</h3>
            <p class="message-class">{{message}}</p>
        </div>
        <div class="cp">
            <img (click)="hide()" [src]="sharedService.imagesUrl + 'Icon-multiply.svg'" />
        </div>
    </div>
</div>